import { jsx } from 'react/jsx-runtime';
import { useMemo } from 'react';
import { resolveOverflowPanelProps } from './overlay-panel.utils.js';
import { createOverflowItemTemplate, createOverflowValueTemplate } from './OverflowTemplate.utils.js';
import { isPlainLabelList, getLabelText } from './plain-label.utils.js';

function useSelectOverflowBehavior(_ref) {
  let {
    itemTemplate,
    valueTemplate,
    optionGroupChildren,
    optionLabel,
    options,
    panelClassName
  } = _ref;
  return useMemo(() => {
    const getOptionLabel = option => getLabelText(option, optionLabel !== null && optionLabel !== void 0 ? optionLabel : 'label');
    const enabled = !itemTemplate && !valueTemplate && !optionGroupChildren && isPlainLabelList(options, getOptionLabel);
    const {
      resolvedPanelClassName
    } = resolveOverflowPanelProps({
      panelClassName,
      shouldUseOverflow: enabled
    });
    return {
      resolvedPanelClassName,
      itemTemplate: createOverflowItemTemplate({
        enabled,
        getLabel: getOptionLabel,
        className: 'ics-overflow-label',
        fallbackTemplate: itemTemplate
      }),
      valueTemplate: createOverflowValueTemplate({
        enabled,
        getLabel: getOptionLabel,
        className: 'ics-overflow-label',
        fallbackTemplate: valueTemplate,
        renderEmpty: _ref2 => {
          let {
            placeholder
          } = _ref2;
          return jsx("span", {
            children: placeholder
          });
        }
      })
    };
  }, [itemTemplate, valueTemplate, optionGroupChildren, optionLabel, options, panelClassName]);
}

export { useSelectOverflowBehavior };
